export const AdminRoutes = {
  adminCenter: '/admin',
} as const;
